import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { SubBlockWeightmentDetailsReportSchema } from "../SubBlockWeightmentDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './CreatePdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './MTable.css';
import _, { forEach } from 'lodash';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "SBWEIGHTMENTDETAILS";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function SubBlockWeightmentDetailsReport(props) {
    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [fields, setFields] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [data, setData] = useState({ details: [], totalNetWeight: 0 });

    const [subBlockWeightmentDetailsReport, setsubBlockWeightmentDetailsReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fieldID: 0,
        searchDate: new Date().toISOString().split('T')[0],
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        field: 0,
        searchDate: "",
    })

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const schema = Joi.object(SubBlockWeightmentDetailsReportSchema).options({ allowUnknown: true });

    const [reportData, setReportData] = useState([]);
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const [customSearch, setCustomSearch] = useState({ regNumber: '' });

    useEffect(() => {
        if (reportData.length > 0 && !isTableHide) {
            handleCustomSearch(customSearch.regNumber);
        }
    }, [customSearch.regNumber]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [subBlockWeightmentDetailsReport.divisionID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [subBlockWeightmentDetailsReport.estateID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [subBlockWeightmentDetailsReport.searchDate, subBlockWeightmentDetailsReport.fieldID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [subBlockWeightmentDetailsReport.divisionID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [subBlockWeightmentDetailsReport.estateID]);

    useEffect(() => {
        setLimit(10);
        setPage(0);
    }, [subBlockWeightmentDetailsReport.searchDate]);


    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),

        )
    }, [subBlockWeightmentDetailsReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [subBlockWeightmentDetailsReport.estateID])

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint()
        )
    }, [subBlockWeightmentDetailsReport.divisionID]);

    useEffect(() => {
    }, [reportData]);

    const flattenedData = [];
    if (data.details && data.details.length > 0) {
        data.details.forEach(row => {
            flattenedData.push({
                ...row,
                employeeID: row.employeeID?.toString(),
                registrationNo: row.registrationNo,
                employeeName: row.employeeName,
                subFieldName: row.subFieldName,
                totalWeight: row.totalWeight,
                totalNetWeight: row.totalNetWeight
            });
        });
    }

    const dataToDisplay = customSearch.regNumber && customSearch.regNumber !== ''
        ? flattenedData.filter(row => {
            return (
                row.employeeID?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.employeeName?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.registrationNo?.toLowerCase().includes(customSearch.regNumber.toLowerCase()) ||
                row.subFieldName?.toLowerCase().includes(customSearch.regNumber.toLowerCase())
            );
        })
        : flattenedData;

    function handleCustomSearch(searchValue) {
        if (!searchValue || searchValue === '') {
            setFilteredData(flattenedData);
        } else {
            const filtered = flattenedData.filter(row => {
                return (
                    row.employeeID?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.employeeName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.taskName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.fieldName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.subFieldName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    row.jobTypeGroup?.toLowerCase().includes(searchValue.toLowerCase())
                );
            });
            setFilteredData(filtered);
        }
    }

    const totalRows = dataToDisplay.length;
    const startIndex = page * limit;
    const endIndex = startIndex + limit;

    function handleChange1(e) {
        setCustomSearch({
            ...customSearch,
            regNumber: e.target.value
        });
    }

    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            estateID: target.value,
            divisionID: "0",
            searchDate: new Date().toISOString().split('T')[0],

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            divisionID: target.value,
            fieldID: "0",
            searchDate: new Date().toISOString().split('T')[0],

        });
    }

    function handleFieldChange(target) {
        validateInputs(target);
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            fieldID: parseInt(target.value),
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            searchDate: target.value

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, SubBlockWeightmentDetailsReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUBBLOCKWEIGHTMENTDETAILSREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setsubBlockWeightmentDetailsReport({
                ...subBlockWeightmentDetailsReport,
                groupID: token.groupID
            });

        } else {
            setsubBlockWeightmentDetailsReport({
                ...subBlockWeightmentDetailsReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(subBlockWeightmentDetailsReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(subBlockWeightmentDetailsReport.estateID);
        setDivisions(data);
    }
    async function getFeildsByCollectionPoint() {
        const fields = await services.GetFieldsByCollectionPointID(parseInt(subBlockWeightmentDetailsReport.divisionID));
        setFields(fields);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        const errorMessages = validate(schema, subBlockWeightmentDetailsReport);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        setCustomSearch({ regNumber: '' });

        const result = await services.GetsubBlockWeightmentDetailsReportData(subBlockWeightmentDetailsReport);
        if (result && result.details && result.details.length > 0) {
            setData({
                details: result.details,
                totalNetWeight: result.totalNetWeight || 0
            });
            getSelectedDropdownValuesForReport(subBlockWeightmentDetailsReport);
            setIsTableHide(false);
            setButtonHide(false);
            setIsReportButtonsEnabled(true);
            setPage(0);
            setLimit(10);

        } else {
            setData({ details: [], totalNetWeight: 0 });
            setIsTableHide(true);
            setIsReportButtonsEnabled(false);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Sub Block Weight Details',
            fileName: 'SubBlockWeightDetailsReport_' + moment().format('YYYY-MM-DD'),
            writeOptions: {}
        };

        const csvHeaders = [
            { label: "Registration Number", value: "registrationNo" },
            { label: "Employee Name", value: "employeeName" },
            { label: "Sub Field Name", value: "subFieldName" },
            { label: "Total Weight (kg)", value: "totalWeight" }
        ];
        var copyOfCsv = _.cloneDeep(data.details).map(row => ({
            ...row,
            subFieldName: row.subFieldName || '-',
            totalWeight: typeof row.totalWeight === 'number' ? row.totalWeight.toFixed(2) : row.totalWeight
        }));
        copyOfCsv.push({},
            {
                registrationNo: "Total Records:",
                employeeName: data.details.length.toString()
            },
            {
                registrationNo: "Total Net Weight:",
                employeeName: data.totalNetWeight.toFixed(2) + " kg"
            }
        );
        var reportDetails = {
            registrationNo: "Group: " + selectedSearchValues.group,
            employeeName: "Operation Entity: " + selectedSearchValues.estate,
            subFieldName: "Collection Point : " + selectedSearchValues.division,
            totalWeight: "Date: " + selectedSearchValues.date
        };
        copyOfCsv.push({},reportDetails);
        var reportDetails2 = {
            registrationNo: "Field: " + selectedSearchValues.field,
        };
        copyOfCsv.push( reportDetails2);

        xlsx(csvHeaders, copyOfCsv, settings, true);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            field: fields[searchForm.fieldID],
            division: divisions[searchForm.divisionID],
            date: searchForm.searchDate
        })
    }

    const paginatedData = dataToDisplay.slice(startIndex, endIndex);

    function clearData() {
        setsubBlockWeightmentDetailsReport({
            ...subBlockWeightmentDetailsReport,
            divisionID: "0",
            fieldID: 0,
            searchDate: new Date().toISOString().split('T')[0],
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            division: "0",
            fieldID: 0,
            searchDate: new Date().toISOString().split('T')[0],
        });
        setErrors({});
        clearTable();
        setButtonHide(true);
        setReportData([]);
        setData({ details: [], totalNetWeight: 0 });
        setIsTableHide(true);
        setCustomSearch({ regNumber: '' });
        trackPromise(getDivisionsForDropDown());
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Sub Block Weighment Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={subBlockWeightmentDetailsReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Operation Entity*</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={subBlockWeightmentDetailsReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point  *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={subBlockWeightmentDetailsReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fieldID" >Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={subBlockWeightmentDetailsReport.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)} >
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            value={subBlockWeightmentDetailsReport.searchDate}
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={() => clearData()}
                                    />
                                </div>
                            </form>

                            {!isTableHide && data.details.length > 0 && (
                                <div className="pt-3">
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Sub Field Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total Weight (kg)</TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paginatedData.length > 0 ? (
                                                    <>
                                                        {paginatedData.map((row, index) => (
                                                            <TableRow key={index} hover>
                                                                <TableCell align="center">{row.registrationNo}</TableCell>
                                                                <TableCell align="center">{row.employeeName}</TableCell>
                                                                <TableCell align="center">
                                                                    {row.subFieldName || '-'}
                                                                </TableCell>
                                                                <TableCell align="right" style={{ fontWeight: "500" }}>
                                                                    {typeof row.totalWeight === 'number'
                                                                        ? row.totalWeight.toFixed(2)
                                                                        : row.totalWeight}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow style={{ backgroundColor: "#d4edda" }}>
                                                            <TableCell
                                                                colSpan={3}
                                                                align="right"
                                                                style={{
                                                                    fontWeight: "bold",
                                                                    borderTop: "2px solid #000",
                                                                    fontSize: "15px",
                                                                }}
                                                            >
                                                                Total Net Weight:
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{
                                                                    fontWeight: "bold",
                                                                    borderTop: "2px solid #000",
                                                                    fontSize: "15px",
                                                                }}
                                                            >
                                                                {data.totalNetWeight.toFixed(2)} kg
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center" style={{ padding: '40px' }}>
                                                            <span style={{ color: '#999', fontSize: '16px' }}>No records found</span>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>

                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={totalRows}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Sub Block Weight Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>

                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={data.details} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}


